import { IObservableArray, isObservableArray } from 'mobx';

export function isArrayLike(possibleArray: any): possibleArray is any[] | IObservableArray[] {
	return Array.isArray(possibleArray) || isObservableArray(possibleArray);
}
